import { render, staticRenderFns } from "./ProjectContacts.vue?vue&type=template&id=5383071b&scoped=true"
import script from "./ProjectContacts.vue?vue&type=script&lang=ts"
export * from "./ProjectContacts.vue?vue&type=script&lang=ts"
import style0 from "./ProjectContacts.vue?vue&type=style&index=0&id=5383071b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5383071b",
  null
  
)

export default component.exports